import Label from '@pinecast/common/Label';
import CommonTextInput from '@pinecast/common/TextInput';
import type {FieldProps} from '@pinecast/common/forms';
import {useField} from '@pinecast/common/forms';
import type {LocalizedReactNode} from '@pinecast/common/types';
import type {CSS} from '@pinecast/styles';
import * as React from 'react';

type Props = {
  autoComplete?: string;
  autoFocus?: boolean;
  cosmeticValue?: string;
  description?: LocalizedReactNode;
  disabled?: boolean;
  error?: React.ReactNode;
  filter?: (value: string) => string;
  inputStyle?: CSS;
  jumbo?: boolean;
  label: LocalizedReactNode;
  maxLength?: number;
  minLength?: number;
  optional?: boolean;
  placeholder?: string;
  style?: CSS;
  suffix?: React.ReactNode;
  type?: 'text' | 'url' | 'email' | 'password' | 'number' | 'tel';
};

const TextInput = (props: FieldProps<Props>) => {
  const {fieldState, fieldApi} = useField(props);
  const {
    autoComplete,
    autoFocus,
    cosmeticValue,
    description,
    disabled,
    error,
    filter,
    inputStyle,
    label,
    maxLength,
    minLength,
    optional,
    placeholder,
    jumbo,
    style,
    suffix,
    type,
  } = props;
  return (
    <Label
      text={label}
      optional={optional}
      subText={description}
      error={(fieldState.error as React.ReactNode) || error}
      style={style}
    >
      <CommonTextInput
        autoComplete={autoComplete}
        autoFocus={autoFocus}
        disabled={disabled}
        invalid={!!fieldState.error}
        maxLength={maxLength}
        minLength={minLength}
        nativeEvents={{
          onBlur: () => {
            fieldApi.setTouched(true);
          },
        }}
        onChange={value => {
          fieldApi.setValue(filter ? filter(value) : value);
          fieldApi.setTouched(true);
        }}
        placeholder={placeholder}
        size={jumbo ? 'large' : 'normal'}
        style={inputStyle}
        suffix={suffix}
        type={type}
        value={
          cosmeticValue ||
          (typeof fieldState.value === 'string' && fieldState.value) ||
          ''
        }
      />
    </Label>
  );
};

export default TextInput;
